function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M.315.934h52.542v41.494H.315z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#3689EA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M99.462 50c0 27.32-22.15 49.462-49.462 49.462C22.675 99.462.538 77.32.538 50 .538 22.68 22.675.538 50 .538 77.312.538 99.462 22.68 99.462 50z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E48868",
  d: "M33 62v17.309s13.553 14.822 26 .345L57.91 62H33z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E48868",
  d: "M44.956 25.017c-14.145.435-16.164 16.741-15.94 30.462.223 13.717 6.062 22.787 15.041 23.484 8.982.697 15.494-8.602 18.186-21.16 2.695-12.556 5.39-33.483-17.287-32.786"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E48868",
  d: "M31.71 50.496s0-5.69-4.683-4.268c-4.683 1.416-.466 14.669 4.683 13.724 5.152-.95 0-9.456 0-9.456M59.492 55.187s.807-5.818 5.752-3.738c4.946 2.084-1.564 15.066-7.092 13.405-5.528-1.66 1.34-9.667 1.34-9.667"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#393762",
  d: "M40.499 47.504a5 5 0 0 0-4.993 4.994 5 5 0 0 0 4.993 4.995 5 5 0 0 0 4.995-4.995 5 5 0 0 0-4.995-4.994m0 11.496C36.914 59 34 56.083 34 52.498A6.503 6.503 0 0 1 40.499 46 6.505 6.505 0 0 1 47 52.498 6.51 6.51 0 0 1 40.499 59M54.501 48.504a5 5 0 0 0-4.995 4.992 5.002 5.002 0 0 0 4.995 4.997 5.001 5.001 0 0 0 4.993-4.997 4.999 4.999 0 0 0-4.993-4.992m0 11.496A6.508 6.508 0 0 1 48 53.496C48 49.913 50.917 47 54.501 47A6.503 6.503 0 0 1 61 53.496 6.506 6.506 0 0 1 54.501 60"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#393762",
  d: "M48.095 54c-.288-.563-.622-.88-.992-.933-.602-.087-1.192.436-1.364.62L45 52.95c.045-.045 1.086-1.088 2.248-.935.713.108 1.302.607 1.752 1.488l-.905.497z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24 13)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#393762",
  d: "M5.07 33.417s1.273 4.507 1.14 8.218l1.738.793V31.692s4.941-2.914 4.676-8.482c0 0 39.68 8.084 40.213 2.12.534-5.963-9.726-6.76-9.726-6.76s5.584-4.506 1.844-10.472c-3.742-5.964-10.544-2.384-10.544-2.384S33.865 2 31.061 1.072c-2.806-.926-4.542 3.05-4.542 3.05s-15.098 6.096-18.57 7.423c-3.476 1.325-2.88 6.497-2.88 6.497s-5.335 3.31-4.702 5.699c.634 2.383 2 9.59 2 9.59s1.876-.58 2.702.086",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#393762",
  d: "M58.371 39s-1.866 6.439 2.772 7.462v6.923l1.003.615s.586-2.727 2.187-3.49L67 39.614 58.371 39z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BA745D",
  d: "M44.88 80c-.311 0-.62-.016-.933-.047-3.856-.36-7.246-2.637-9.8-6.595-.23-.356-.186-.881.1-1.171.28-.287.702-.24.932.12 2.316 3.587 5.384 5.655 8.868 5.983 3.618.32 6.932-1.474 9.8-5.408.25-.34.672-.361.94-.052.27.314.284.842.039 1.184C51.956 77.943 48.535 80 44.88 80"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BA745D",
  stroke: "#BB745A",
  d: "M45.253 72.744c-2.028-.003-3.896-.982-5.401-2.837a.476.476 0 0 1 0-.588c.135-.156.357-.152.493.017 1.364 1.68 3.056 2.571 4.888 2.575 1.902-.005 3.553-1.05 4.878-3.14.116-.181.335-.211.488-.07a.484.484 0 0 1 .072.589c-1.327 2.087-3.022 3.268-4.93 3.435a5.33 5.33 0 0 1-.488.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3689EA",
  d: "M80 99c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm5.827-21L88 80.09 77.695 90 72 84.522l2.173-2.09 3.522 3.389L85.827 78z"
}));

var SvgPritmanCheck = function SvgPritmanCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPritmanCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pritman-check.7281597a.svg";
export { ForwardRef as ReactComponent };